import React, { Suspense } from 'react';

export function LazyRoute<T>({
  Component,
  fallback,
  ...rest
}: T & {
  Component: React.FC<T>;
  fallback?: React.ReactNode;
}) {
  const props = rest as T & JSX.IntrinsicAttributes;
  return (
    <Suspense fallback={fallback}>
      <Component {...props} />
    </Suspense>
  );
}
